import { extend, localize } from 'vee-validate'
import {
  required as rule_required,
  email as rule_email,
  min as rule_min,
  confirmed as rule_confirmed,
  regex as rule_regex,
  between as rule_between,
  alpha as rule_alpha,
  integer as rule_integer,
  digits as rule_digits,
  alpha_dash as rule_alpha_dash,
  alpha_num as rule_alpha_num,
  length as rule_length,
} from 'vee-validate/dist/rules'
import ar from 'vee-validate/dist/locale/ar.json'
import en from 'vee-validate/dist/locale/en.json'
import zh_CN from 'vee-validate/dist/locale/zh_CN.json'
// eslint-disable-next-line object-curly-newline
import { validatorPositive, validatorUrlValidator, validatorPassword, validatorCreditCard, validatorPhoneNumber} from './validators'

// ////////////////////////////////////////////////////////
// General
// ////////////////////////////////////////////////////////


export const required = extend('required', rule_required)

export const email = extend('email', rule_email)

export const min = extend('min', rule_min)

export const confirmed = extend('confirmed', rule_confirmed)

export const regex = extend('regex', rule_regex)

export const between = extend('between', rule_between)

export const alpha = extend('alpha', rule_alpha)

export const integer = extend('integer', rule_integer)

export const digits = extend('digits', rule_digits)

export const alphaDash = extend('alpha-dash', rule_alpha_dash)

export const alphaNum = extend('alpha-num', rule_alpha_num)

export const length = extend('length', rule_length)

export const positive = extend('positive', {
  validate: validatorPositive,
  message: 'Please enter positive number!',
})



export const phoneNumber = extend('phoneNumber', {
  validate: validatorPhoneNumber
})



export const credit = extend('credit-card', {
  validate: validatorCreditCard,
  message: 'It is not valid credit card!',
})

export const password = extend('password', {
  validate: validatorPassword
})

export const url = extend('url', {
  validate: validatorUrlValidator,
  message: 'URL is invalid',
})

// Install English and Arabic localizations.
localize({
  zh_CN: {
    "messages": {
      "alpha": "{_field_}只能包含字母字符",
      "alpha_dash": "{_field_}能够包含字母数字字符、破折号和下划线",
      "alpha_num": "{_field_}只能包含字母数字字符",
      "alpha_spaces": "{_field_}只能包含字母字符和空格",
      "between": "{_field_}必须在{min}与{max}之间",
      "confirmed": "确认密码不能和密码匹配",
      "digits": "{_field_}必须是数字，且精确到{length}位数",
      "dimensions": "{_field_}必须在{width}像素与{height}像素之间",
      "email": "这不是一个有效的邮箱",
      "excluded": "{_field_}不是一个有效值",
      "ext": "{_field_}不是一个有效的文件",
      "image": "{_field_}不是一张有效的图片",
      "oneOf": "{_field_}不是一个有效值",
      "integer": "{_field_}必须是整数",
      "length": "{_field_}长度必须为{length}",
      "max": "{_field_}不能超过{length}个字符",
      "max_value": "{_field_}必须小于或等于{max}",
      "mimes": "{_field_}不是一个有效的文件类型",
      "min": "{_field_}必须至少有{length}个字符",
      "min_value": "{_field_}必须大于或等于{min}",
      "numeric": "{_field_}只能包含数字字符",
      "regex": "{_field_}格式无效",
      "required": "{_field_}是必须的",
      "required_if": "{_field_}是必须的",
      "size": "{_field_}必须小于{size}KB",
      "double": "{_field_}字段必须为有效的小数",
      "phoneNumber": "这不是一个有效的电话号码",
      "password": '你的密码必须包含一个大写，一个小写，还有一个数字',
    },
    names: {
      Email:  "电子邮箱",
      Username: "用户名",
      Password: "密码",
      PhoneNumber: "电话号码",
      Password_confirmation:"确认密码",
      batchCode: "批次号码"
    }

  },
})

localize("zh_CN")

// ////////////////////////////////////////////////////////
// NOTE:
// Quasar validation for reference only
// Remove this note once development is finished and make sure to
// to convert all of them in veevalidate version
// ////////////////////////////////////////////////////////

// export const required = (val) => {
//   return (val && val.length > 0) || '*Field is required'
// }

// export const required_obj = (obj) => {
//   if (obj === null || obj === undefined) return '*Field is required'
//   return (Object.entries(obj).length > 0 && obj.constructor === Object) || '*Field is required'
// }

// export const no_blank_spaces_arr = (arr) => {
//   return arr.every(val => (val.trim() && val.trim().length > 0)) || 'Blank Spaces are not allowed'
// }

// export const url = val => {
//   // If blank return
//   if (val === undefined || val === null || val.length === 0) return true

//   // Used
//   // https://stackoverflow.com/questions/4314741/url-regex-validation

//   // Other
//   // https://stackoverflow.com/questions/5717093/check-if-a-javascript-string-is-a-url
//   // https://www.w3resource.com/javascript-exercises/javascript-regexp-exercise-9.php
//   // https://www.geeksforgeeks.org/how-to-validate-url-using-regular-expression-in-javascript/

//   /* eslint-disable no-useless-escape */
//   const re = /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/
//   /* eslint-enable no-useless-escape */
//   return re.test(val) || 'URL is invalid'
// }

// export const date = val => {

//   // If blank return
//   if (val === undefined || val === null || val.length === 0) return true

//   // https://github.com/quasarframework/quasar/blob/dev/ui/src/utils/patterns.js
//   return /^-?[\d]+\/[0-1]\d\/[0-3]\d$/.test(val) || 'Date is invalid'
// }

// export const max = (val, max) => {

//   // If blank return
//   if (val === undefined || val === null) return true

//   return val.length <= max || `More than ${max} characters are not allowed`
// }

// export const max_arr = (val, max) => {
//   return val.length <= max || `More than ${max} values are not allowed`
// }

// export const min = (val, min) => {

//   // If blank return
//   if (val === undefined || val === null || val.length === 0) return true

//   return val.length >= min || `Minimum ${min} characters are required`
// }

// export const num_range = (val, min, max) => {

//   // If blank return
//   if (val === undefined || val === null || val.length === 0) return true

//   const msg = 'Value is invalid'
//   if (min === null) return val <= max || msg
//   else if (max === null) return val >= min || msg
//   else return (val >= min && val <= max) || msg
// }
